<!--
 * @Author: 
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Gaho
 * @LastEditTime: 2024-07-16 11:36:25
 * @Description: 这是早期的播放播放组件，现在主要使用 howl 处理音效 
-->
<template>
    <Sound
        :audio="audio"
        :model-value="modelValue"
        :volume="volume"
        @update:model-value="$emit('update:modelValue', $event)"
    />
</template>

<script setup lang="ts">
import SpaceDiceWinSound from '@/assets/mp3/spaceDice/spacedice_win.mp3';
import SpaceDiceLoseSound from '@/assets/mp3/spaceDice/spacedice_lose.mp3';
import SpaceDiceBetSound from '@/assets/mp3/spaceDice/spacedice_bet.mp3';
import spaceDiceSwipe from '@/assets/mp3/spaceDice/spacedice_swipe.mp3';
import SpaceDiceNum from '@/assets/mp3/spaceDice/spacedice_num.mp3';
import spaceDiceDrag from '@/assets/mp3/spaceDice/spacedice_drag.mp3';
import spaceDiceOut from '@/assets/mp3/spaceDice/spacedice_out.mp3';
import { safeHtmlAudioPlay } from '~/utils/sound';

type soundsType = 'spaceDiceWin' | 'spaceDiceLose' |
    'spaceDiceSwipe' | 'spaceDiceBet' | 'spaceDiceNum' |
    'spaceDiceDrag' | 'spaceDiceOut';

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    name: {
        type: String as PropType<soundsType>,
        default: '',
        required: true,
    },
    isLoop: {
        type: Boolean,
        default: false,
        required: false

    },
    volume: {
        type: Number,
    }

})

let audio = null as HTMLAudioElement

onBeforeMount(() => {
    if (import.meta.server) return;
    switch (props.name) {
        case 'spaceDiceWin':
            audio = new Audio(SpaceDiceWinSound)
            break;
        case 'spaceDiceLose':
            audio = new Audio(SpaceDiceLoseSound)
            break;
        case 'spaceDiceSwipe':
            audio = new Audio(spaceDiceSwipe)
            break;
        case 'spaceDiceBet':
            audio = new Audio(SpaceDiceBetSound)
            break;
        case 'spaceDiceNum':
            audio = new Audio(SpaceDiceNum)
            audio.loop = props.isLoop
            audio.playbackRate = 1.5
            break;
        case 'spaceDiceDrag':
            audio = new Audio(spaceDiceDrag)
            break;
        case 'spaceDiceOut':
            audio = new Audio(spaceDiceOut)
            break;
        default:
            break;
    }

})
watch(() => props.modelValue, (newVal) => {
    if (!audio) return;
    if (newVal) {
        audio.currentTime = 0;
        safeHtmlAudioPlay(audio);
    } else {
        audio.pause();
    }
})










</script>